import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// SPA navigation keeps the previous scroll position, so reset it on every new page.
// Back/forward (POP) is left to the browser so users return to where they were.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;

    if (hash) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, navigationType]);

  return null;
}
